module.exports = __webpack_public_path__ + "img/design-thinking.5a9700ec.svg";